module.exports = __webpack_public_path__ + "img/img3.68792b54.jpg";